/**
 * Payment Service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceItemSimpleDto } from './invoiceItemSimpleDto';


export interface InvoiceAddDto { 
    amountRequested?: number;
    amountPaid?: number;
    currency: InvoiceAddDto.CurrencyEnum;
    invoiceDate: string;
    paid?: boolean;
    fakturaInvoiceId: string;
    creditCardFee?: number;
    vatRate?: number;
    porto?: number;
    invoiceItems?: Array<InvoiceItemSimpleDto>;
    transactionIds?: Array<number>;
    paymentAccountId: number;
}
export namespace InvoiceAddDto {
    export const CurrencyEnum = {
        Usd: 'USD',
        Eur: 'EUR',
        Cad: 'CAD'
    } as const;
    export type CurrencyEnum = typeof CurrencyEnum[keyof typeof CurrencyEnum];
}


